import {formatDateToBR} from "../../../../../utils/time";
import {SETableColumnsProps} from "../../../../components/SETable";
import {Grid} from "@mui/material";
import {RiDeleteBin6Line,} from "react-icons/ri";
import React from "react";
import SETableIconButton from "../../../../components/SETable/SETableIconButton";
import {cnpjMask} from "../../../../../utils/mask";

interface TableColumnsProps {
  handleEdit?: (data?: any) => void;
  handleCopy?: (data?: any) => void;
  handleUpdateStatus?: (data?: any) => void;
  handleDelete?: (id?: number | string) => void;
}

export const tableColumns = ({
  handleEdit = () => {},
  handleDelete = () => {},
  handleUpdateStatus = () => {},
}: TableColumnsProps): SETableColumnsProps[] => [
  {
    id: 'dataCriacao',
    label: 'Data',
    customField: formatDateToBR,
  },
  {
    id: 'atendente',
    customField: (atendente) => <p>{atendente?.uf?.sigla}</p>,
    label: 'UF',
    align: 'left',
    minWidth: 10,
  },
  {
    id: 'cnpj',
    label: 'CNPJ',
    align: 'left',
    minWidth: 135,
    customField: cnpjMask,
  },
  {
    id: 'atendente',
    customField: (atendente) => <p>{atendente?.nome}</p>,
    label: 'Nome do atendente',
    align: 'left',
    minWidth: 10,
  },
  {
    id: "status",
    label: "Status",
    align: "center",
    sortable: false,
    width: 320,
    customField: (value: any, row: any) => (
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={6} container alignItems="center" justifyContent="center">
          <SETableIconButton onClick={() => handleDelete(row.id)}>
            <RiDeleteBin6Line size={20} color="#555770" />
          </SETableIconButton>
        </Grid>
      </Grid>
    ),
  },
];
